module.exports = __webpack_public_path__ + "img/icon-national-id-color.a9f67162.png";